import computerRequestElements from './general-request-elements'
import generalKendoWindow from "./general-kendo-window";
import createCapexRequestController from "../shared/capex-request-controller";

const controller = createCapexRequestController({
    baseUrl: '/Finance/CapExGeneralRequest',
    submitAction: 'SubmitGeneralRequest',
});

export const {
    getApprovalFormData,
    setApprovalControlsBusy,
    approveRequest,
    rejectRequest,
    approvalEvent,
    rejectionEvent,
} = controller;

export default function () {
    computerRequestElements();
    controller.init();
    generalKendoWindow();
}
